import { Reveal, SectionHeader } from "@/components/Reveal";

const facts = [
  { label: "Sectors", value: "Pharmaceutical · Healthcare · Outdoor" },
  { label: "Horizon", value: "Long-term. No fixed exit clock." },
  { label: "Posture", value: "Control and significant minority" },
];

const WhoWeAre = () => (
  <section id="who-we-are" className="py-24 md:py-36" data-testid="who-we-are-section">
    <div className="max-w-screen-2xl mx-auto px-6 md:px-12">
      <SectionHeader number="01" title="Who We Are" testId="who-we-are" />
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
        <Reveal className="lg:col-span-7">
          <p className="font-display font-light text-2xl md:text-4xl leading-snug tracking-tight text-[#f2f0eb]" data-testid="who-we-are-statement">
            We back proven businesses at pivotal moments — <span className="text-[#8a8a8a]">a founder stepping
            back, a company ready to scale, an acquisition worth making</span> — with
            patient capital and hands-on operating experience.
          </p>
          <p className="mt-10 text-[#a8a8a8] leading-relaxed max-w-xl">
            Nomad Capital was built on a simple belief: enduring value is
            created by staying in motion — moving toward essential markets,
            proven demand, and the people who understand them best. We are
            not intermediaries. We commit our own judgment, our own network,
            and our own time to every business we back.
          </p>
        </Reveal>
        <div className="lg:col-span-5">
          <div className="border-t border-white/[0.08]">
            {facts.map((f, i) => (
              <Reveal key={f.label} delay={0.1 + i * 0.1}>
                <div className="py-7 border-b border-white/[0.08] flex flex-col gap-2" data-testid={`fact-${f.label.toLowerCase()}`}>
                  <span className="font-mono-tech text-[10px] tracking-[0.3em] uppercase text-[#e65c00]">{f.label}</span>
                  <span className="font-display text-lg text-[#f2f0eb]">{f.value}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>

      <Reveal delay={0.2}>
        <div className="mt-20 flex flex-col md:flex-row md:items-center gap-6 md:gap-12 border border-[#0a4d3c] bg-[#0a4d3c]/20 px-8 md:px-12 py-10" data-testid="criteria-band">
          <span className="font-mono-tech text-[10px] tracking-[0.3em] uppercase text-[#14b48a] whitespace-nowrap">
            What we look for
          </span>
          <p className="text-[#c9c7c2] leading-relaxed">
            Proven demand and recurring or repeat revenue. Real products serving
            essential needs. Owners who care about what happens after the close.
            If that sounds like your business — or your portfolio — we should talk.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default WhoWeAre;
